import { useParams } from 'react-router';

import UseRestrictionPolicyJa from './ja';
import UseRestrictionPolicyKo from './ko';
import UseRestrictionPolicyTh from './th';
import UseRestrictionPolicyZh from './zh';

const UseRestrictionPolicy = () => {
  const { language = 'ko' } = useParams();

  if (language === 'th') return <UseRestrictionPolicyTh />;
  else if (language === 'zh') return <UseRestrictionPolicyZh />;
  else if (language === 'ja') return <UseRestrictionPolicyJa />;
  return <UseRestrictionPolicyKo />;
};

export default UseRestrictionPolicy;
